import { useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { ToastAction } from "@/components/ui/toast";

// Listens for the `pwa-update-available` window event dispatched by the SW
// registration in client/src/main.tsx and surfaces a persistent toast prompting
// the user to refresh. Clicking the action button activates the waiting SW
// via window.activatePwaUpdate, which triggers a controllerchange + reload.
export function ServiceWorkerUpdateToast() {
  const { toast } = useToast();

  useEffect(() => {
    const handler = () => {
      toast({
        title: "Neue Version verfügbar",
        description: "Eine neue Version der App ist bereit.",
        duration: Infinity,
        action: (
          <ToastAction
            altText="Jetzt aktualisieren"
            onClick={() => (window as any).activatePwaUpdate?.()}
          >
            Jetzt aktualisieren
          </ToastAction>
        ),
      });
    };

    window.addEventListener("pwa-update-available", handler);
    return () => window.removeEventListener("pwa-update-available", handler);
  }, [toast]);

  return null;
}
